import { cn } from '@/lib/utils/helpers'
import Link from 'next/link'

export const DocSubHeading = ({ text, className, children }) => {
  return (
    <p
      className={cn(
        'text-blue-600 text-base font-semibold leading-normal font-sans',
        className,
      )}
    >
      {children || text}
    </p>
  )
}

export const DocHeading = ({ text, className, children }) => {
  return (
    <p
      className={cn(
        'self-stretch text-white text-3xl font-semibold font-sans lg:leading-10',
        className,
      )}
    >
      {children || text}
    </p>
  )
}

export const DocParagraph = ({ text, className, children }) => {
  return (
    <p
      className={cn(
        'text-gray-400 text-lg font-normal leading-loose font-sans',
        className,
      )}
    >
      {children || text}
    </p>
  )
}

export const DocSimpleParagraph = ({ text, className, children }) => {
  return (
    <p
      className={cn(
        'text-[#98A2B3] text-lg font-normal leading-[30px] font-sans',
        className,
      )}
    >
      {children || text}
    </p>
  )
}

export const DocLink = ({ text, className, children, href }) => {
  return (
    <Link
      href={href || '#'}
      className={cn(
        'text-blue-600 text-lg font-medium underline leading-loose',
        className,
      )}
    >
      {children || text}
    </Link>
  )
}

export const DocQuote = ({ className, children, containerClass }) => {
  return (
    <blockquote
      className={cn('pl-[18px] border-l-4 border-gray-300', containerClass)}
    >
      <p
        className={cn(
          'text-lg italic font-medium leading-relaxed text-gray-400',
          className,
        )}
      >
        {children}
      </p>
    </blockquote>
  )
}
